<script>
	import {Router, Route} from 'svelte-routing';

	import Header from "./Header.svelte";
	import Home from "./Home.svelte";
	import Time from "./Time.svelte";
	import Techniques from "./Techniques.svelte";
</script>

<style>
	:global(body) {
		padding: 0;
		background-color: var(--dark) !important;
	}
</style>

<div class="d-flex flex-column h-100">
	<Header />
	<Router>
		<Route path="*" component={Home} />
		<Route path="/time" component={Time} />
		<Route path="/techniques" component={Techniques} />
	</Router>
</div>

<svelte:head>
	<link
		rel="stylesheet"
		href="https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/css/bootstrap.min.css"
		integrity="sha384-TX8t27EcRE3e/ihU7zmQxVncDAy5uIKz4rEkgIXeMed4M0jlfIDPvg6uqKI2xXr2"
		crossorigin="anonymous" />
	<!-- <script
		src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js">
	</script> -->
	<!-- <script
		src="https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/js/bootstrap.bundle.min.js"
		integrity="sha384-ho+j7jyWK8fNQe+A12Hb8AhRq26LrZ/JpcUGGOn+Y7RsweNrtN/tE3MoK7ZeZDyx"
		crossorigin="anonymous">
	</script> -->
	<!-- Font awesome -->
	<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.1/css/all.min.css">
	
	<!-- Web App Manifest -->
	<link rel="manifest" href="/manifest.json">

	<!-- Service Worker registration -->
	<script src="/app.js"></script>
</svelte:head>
